import { HttpClient } from '@angular/common/http';

import { BaseEntity } from '../entities/base/base.entity';
import { BaseReadOnlyService } from './base-readonly.service';

export abstract class BaseCRUDService<T extends BaseEntity> extends BaseReadOnlyService<T> {

    constructor(protected http: HttpClient, actionUrl: string) {
        super(http, actionUrl);
    }

    post(item: T) {
        return this.http.post<T>(this.baseUrl, item);
    }

    put(id: number, item: T) {
        return this.http.put<T>(this.baseUrl + '/' + id, item);
    }

    delete(id: number) {
        return this.http.delete<void>(this.baseUrl + '/' + id);
    }
}
